import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import type { SxProps } from '@mui/system'
import useDialog from 'global/hooks/useDialog'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import ConfidentialReportingLineDialog from './ConfidentialReportingLineDialog'

interface FooterProps {
  sx?: SxProps
}

const Footer = ({
  sx,
}: FooterProps): ReactElement => {
  const { t } = useTranslation()
  const confidentialReportingLineDialog = useDialog<typeof ConfidentialReportingLineDialog>({
    onAction: () => window.open('https://secure.ethicspoint.eu/domain/media/en/gui/107315/index.html', '_blank', 'noopener'),
  })

  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        sx={sx}
      >
        <Link
          variant="p3"
          href="https://privacy.kuehne-nagel.com/road-carrier-solution-privacy-policy"
          target="_blank"
        >
          {t('footer.privacy_policy')}
        </Link>
        <Link
          component="button"
          type="button"
          variant="p3"
          onClick={confidentialReportingLineDialog.handleOpen}
        >
          {t('footer.confidential_reporting_line.label')}
        </Link>
      </Stack>
      <ConfidentialReportingLineDialog
        open={confidentialReportingLineDialog.isOpen}
        onAction={confidentialReportingLineDialog.handleAction}
        onClose={confidentialReportingLineDialog.handleClose}
      />
    </>
  )
}

export default Footer
